import React from 'react';
import Construccion from './pages/Construccion';

function App() {
  return (
    <div>
      <Construccion />
    </div>
  );
}

export default App;